import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StatusMessage } from '@components/layout/StatusBar/types';
import i18next from 'i18next';

interface AppState {
  status: StatusMessage;
}

const initialState: AppState = {
  status: {
    type: 'info',
    message: i18next.t('status.ready'),
    timestamp: Date.now(),
    details: i18next.t('status.details'),
  },
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setStatus: (state, action: PayloadAction<StatusMessage>) => {
      state.status = {
        ...action.payload,
        timestamp: Date.now(),
      };
    },
    resetStatus: state => {
      state.status = {
        type: 'info',
        message: i18next.t('status.ready'),
        timestamp: Date.now(),
        details: i18next.t('status.details'),
      };
    },
  },
});

export const { setStatus, resetStatus } = appSlice.actions;

export default appSlice.reducer;
